export interface ContractCurrencyOption {
  code: string
  label: string
  symbol: string
}

/** Currencies requested by KCG team for contract pricing. */
export const CONTRACT_CURRENCY_OPTIONS: ContractCurrencyOption[] = [
  { code: 'USD', label: 'USD', symbol: '$' },
  { code: 'ZAR', label: 'ZAR', symbol: 'R' },
  { code: 'EUR', label: 'EUR', symbol: '€' },
  { code: 'CAD', label: 'CAD', symbol: '$' },
  { code: 'GBP', label: 'GBP', symbol: '£' },
]

export const DEFAULT_CONTRACT_CURRENCY = 'USD'

export function getContractCurrencySymbol(code?: string | null): string {
  const match = CONTRACT_CURRENCY_OPTIONS.find(
    (c) => c.code === (code || DEFAULT_CONTRACT_CURRENCY).toUpperCase()
  )
  return match?.symbol ?? (code || DEFAULT_CONTRACT_CURRENCY).toUpperCase()
}

export function formatContractPrice(
  price?: string | null,
  currency?: string | null
): string {
  if (!price?.trim() || price === '-') return '—'
  const code = (currency || DEFAULT_CONTRACT_CURRENCY).toUpperCase()
  const symbol = getContractCurrencySymbol(code)
  const numeric = price
    .trim()
    .replace(/^(USD|ZAR|EUR|CAD|GBP)\s*/i, '')
    .replace(/^[$€£R]+\s*/, '')
    .replace(/,/g, '')
    .trim()
  const val = parseFloat(numeric)
  const amount = Number.isNaN(val)
    ? numeric
    : val.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })
  return `${code} ${symbol}${amount}`
}
